<template>
  <div class="NUOVOTICKET">
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <!-- <BreadCrumbs/> -->

        <v-flex d-flex xs12>
          <h4>INSERIMENTO NUOVO RAPPORTINO</h4>
        </v-flex>

        <v-flex d-flex xs12>
          <v-form ref="form" v-model="valid" lazy-validation>
            <v-flex xs12 sm12 d-flex>
              <v-select
                :items="clienti"
                item-text="value"
                item-value="c_bpartner_id"
                label="Seleziona Cliente"
              ></v-select>
              <v-select :items="indirizzi" label="Seleziona Indirizzo"></v-select>
            </v-flex>

            <v-flex xs12 sm12 d-flex>
              <v-select
                :items="progettoSelectList"
                item-text="name"
                item-value="c_project_id"
                label="Seleziona Progetto"
              ></v-select>
            </v-flex>

            <v-flex xs12 lg6>
              <v-menu
                ref="menu1"
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="dateFormatted"
                    label="Date"
                    hint="MM/DD/YYYY format"
                    persistent-hint
                    prepend-icon="event"
                    @blur="date = parseDate(dateFormatted)"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="date" no-title @input="menu1 = false"></v-date-picker>
              </v-menu>
              <!--<p>
                Date in ISO format:
                <strong>{{ dateFormatted }}</strong>
              </p>-->
            </v-flex>

            <!--
            <v-flex md12 lg4 lg-offset8>
              <v-time-picker v-model="oraInizio" format="24hr"></v-time-picker>
              <v-time-picker v-model="oraFine" format="24hr"></v-time-picker>
            </v-flex>
            {{oraInizio}}
            -->

            <v-text-field
              v-model="oreImpiegate"
              label="Ore Impiegate"
              placeholder="Ad es 2.15 (multipli di 15 minuti)"
              :rules="rules"
              validate-on-blur
            ></v-text-field>

            <v-flex xs12 sm12 d-flex>
              <v-select
                :items="luoghiSelectList"
                v-model="luogo"
                item-text="name"
                item-value="value"
                label="Luogo attività"
              ></v-select>
            </v-flex>
            <!--
            <v-flex xs12 sm12 d-flex>
              <v-switch v-model="fatturabile" :label="`Fatturabile`"></v-switch>
              <v-switch v-model="visibile" :label="`Visibile Al Cliente`"></v-switch>
              <v-switch v-model="conteggioUscita" :label="`Conteggio Uscita`"></v-switch>
            </v-flex>
            -->
            <v-textarea
              name="input-7-1"
              box
              label="Descrizione attività"
              auto-grow
              value
              v-model="descrizione"
            ></v-textarea>

            <v-textarea
              name="input-7-1"
              box
              label="Nota interna attività"
              auto-grow
              value
              v-model="nota"
            ></v-textarea>

            <v-textarea
              name="input-7-1"
              box
              label="Materiale impiegato"
              auto-grow
              value
              v-model="materialeImpiegato"
            ></v-textarea>

            <v-btn
              :disabled="isSalvataggioDisabilitato"
              color="warning"
              @click="salvaRapportino()"
            >Inserisci Rapportino</v-btn>
          </v-form>
        </v-flex>
      </v-layout>

      <div class="text-xs-center">
        <v-dialog v-model="dialogSave" width="300">
          <v-card>
            <v-card-title class="headline grey lighten-2" primary-title>Stato</v-card-title>
            <v-card-text>Operazione completata</v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="dialogSave = false">OK</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </v-container>

    <!--
    <DialogOperationRunning
      :dialogTitle="operationRunningTitle"
      :dialogMessage="progressMessage"
      :dialog.sync="progressMessageEnable"
      v-bind:isactive="progressMessageEnable"
    />-->
  </div>
</template>

<script src="https://unpkg.com/vue/dist/vue.js"></script>
<script src="https://unpkg.com/vuetify/dist/vuetify.js"></script>

<script>
// Vue.component('file-upload', VueUploadComponent)
/* eslint-disable */
// import axios from 'axios';
//import mixinCommon from "@/mixin/MixingCommonComp.js";

export default {
  //mixins: [mixinCommon],
  data() {
    return {
      ///
      oreImpiegate: null,
      date: new Date().toISOString().substr(0, 10),
      dateFormattedISO: null,
      //dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
      dateFormatted: this.formatDate(new Date().toISOString().substr(0, 10)),
      menu1: false,
      menu2: false,
      ///
      clienti: {}, // ["cliente 1", "cliente 2"],
      indirizzi: ["indirizzo 1", "indirizzo 2"],
      luoghiSelectList: [
        { name: "Sede", value: "S" },
        { name: "Cliente", value: "C" },
        { name: "Telefono", value: "T" }
      ],
      progettoSelectList: [
        { name: "Progetto1", c_project_id: "1000025" },
        { name: "Progetto13", c_project_id: "1000026" },
        { name: "Progetto56", c_project_id: "1000027" }
      ],
      ///
      descrizione: "",
      nota: "",
      //oraInizio: null,
      //oraFine: null,
      luogo: null,
      fatturabile: true,
      visibile: true,
      materialeImpiegato: "",
      conteggioUscita: null,

      ///
      operationRunningTitle: "INFO",
      errorDialogTitle: "Error",
      toolbartitle: "",
      valid: true,
      toolbarcontent: [],
      selectedProducts: [],
      searchEnabled: false,
      files: [],
      //campi da salvare
      titolo: "",
      //campo descrizione del problema
      descProblema: "",
      //severita
      selectedSeverity: null,
      //////////////////////////////////// UPLOAD
      title: "Image Upload",
      dialogSave: false,
      imageName: "",
      imageUrl: "",
      imageFile: "",
      rules: [
        v => {
          //console.log(`Rule called for ${v}`);
          var stringa = v;
          var oraMinuti = stringa.split(".");
          if (oraMinuti.length != 2) {
            return "Deve essere nel formato 2.20";
          } else {
            console.log(oraMinuti);
            var risultato = parseInt(oraMinuti[1] % 15);
            console.log(risultato);
            if (risultato != 0) {
              return "I minuti devono essere multipli di 15";
            } else {
              return true;
            }
          }
          return "Error";
        }
      ]
    };
  },

  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    selezionato(item) {
      console.log("selezionato id ->" + item.id);
    },
    formatDateISO(date) {
      if (!date) return null;

      const [day, month, year] = date.split("-");
      return `${year}-${month}-${day}`;
    },

    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [day, month, year].join("-"); // + "T00:00:00";
    },
    getListaClienti() {
      var query =
        "SELECT bp.c_bpartner_id, bp.value \
        from C_Bpartner bp where \
        bp.AD_Client_ID = 1000000 AND bp.iscustomer = 'Y' AND bp.isactive = 'Y'";
      var fieldTypes = {};
      fieldTypes = [
        {
          name: "c_bpartner_id",
          type: "n"
        },
        {
          name: "value",
          type: "s"
        }
      ];

      var parameters = {
        query: query,
        fieldTypes: fieldTypes,
        urlMethod: "/pcli/getQueryResult"
      };

      this.$store.dispatch("postAxiosAction", parameters).then(response => {
        console.log(response);
        //this.dettaglioCurrentItem = response;
        if (response.result == "KO") {
          alert(response.message);
        } else {
          this.clienti = response;
        }
      });
    },
    getListaCommesse() {
      var query =
        "select p.c_project_id, p.name, p.value, p.datecontract, p.c_bpartner_id \
        from c_project p \
        where p.AD_Client_ID = 1000000 and p.isactive = 'Y'";
      var fieldTypes = {};
      fieldTypes = [
        {
          name: "c_project_id",
          type: "n"
        },
        {
          name: "name",
          type: "s"
        },
        {
          name: "value",
          type: "s"
        },
        {
          name: "datecontract",
          type: "s"
        },
        {
          name: "c_bpartner_id",
          type: "n"
        }
      ];

      var parameters = {
        query: query,
        fieldTypes: fieldTypes,
        urlMethod: "/pcli/getQueryResult"
      };

      this.$store.dispatch("postAxiosAction", parameters).then(response => {
        console.log(response);
        //this.dettaglioCurrentItem = response;
        if (response.result == "KO") {
          alert(response.message);
        } else {
          this.progettoSelectList = response;
        }
      });
    },
    salvaRapportino() {
      var parameters = {
        titolo: this.titolo,
        descProblema: this.descProblema,
        selectedSeverity: this.selectedSeverity
      };

      var userid = this.$session.get("ad_user_id");
      var cbpartnerid = this.$session.get("c_bpartner_id");
      //console.log(userid);

      var d = new Date();

      var data = {
        R_RequestType_ID: "101",
        Priority: "9",
        Subject: this.titolo,
        Summary: this.descProblema,
        ConfidentialType: "C",
        ConfidentialTypeEntry: "C",
        DueType: "5",
        StartDate: this.formatDate(d), // "2019-04-16T00:00:00",
        SalesRep_ID: 1000000,
        AD_User_ID: userid,
        C_BPartner_ID: cbpartnerid
      };

      var datadef = {
        R_RequestType_ID: "n",
        Priority: "s",
        Subject: "s",
        Summary: "s",
        ConfidentialType: "s",
        ConfidentialTypeEntry: "s",
        DueType: "s",
        StartDate: "d",
        SalesRep_ID: "n",
        AD_User_ID: "n",
        C_BPartner_ID: "n"
      };

      parameters.webServiceName = "CreateRequest";
      parameters.data = data;
      parameters.datadef = datadef;

      console.log(parameters);

      this.$store.dispatch("ticket/salvaTicket", parameters).then(
        response => {
          console.log("ticket/salvaTicket");
          console.log(response);
          //this.dettaglioCurrentItem = response;
          if (response.data.result == "KO") {
            alert(response.data.message);
          } else {
            this.dialogSave = true;
            var recordID = response.data.recordID;
            //data = {

            parameters = {};
            parameters.record_id = recordID;
            parameters.ad_table_id = 417;
            parameters.ad_client_id = this.$session.get("ad_client_id");
            parameters.ad_org_id = this.$session.get("ad_org_id");
            //uuid: "C",
            parameters.fileName = this.imageName;
            parameters.fileData = this.imageFile;
            parameters.debug = true;

            //};
            /*
            datadef = {
              record_id: "n",
              ad_table_id: "n",
              ad_client_id: "s",
              ad_org_id: "s",
              uuid: "s",
              fileName: "s",
              fileData: "s"
            };*/

            parameters.urlMethod = "/pcli/uploadFilesPost";
            //parameters.data = data;
            //parameters.datadef = datadef;
            /*console.log(parameters);
            console.log(this.imageFile);*/
            console.log(this.imageFile);
            console.log(JSON.stringify(this.imageFile));

            //salva allegato
            this.$store.dispatch("ticket/saveAttachment", parameters).then(
              response => {
                //console.log("ticket/salvaTicket");
                console.log(response);
                //this.dettaglioCurrentItem = response;
                /*
                if (response.data.result == "KO") {
                  alert(response.data.message);
                } else {
                  this.dialogSave = true;
                }*/
              },
              error => {
                console.error("Nessun dato dal server");
              }
            );
          }
        },
        error => {
          console.error("Nessun dato dal server");
        }
      );
    },
    pickFile() {
      this.$refs.image.click();
    },
    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.imageName = files[0].name;
        if (this.imageName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.imageUrl = fr.result;
          this.imageFile = files[0]; // this is an image file that can be sent to server...
        });
      } else {
        this.imageName = "";
        this.imageFile = "";
        this.imageUrl = "";
      }
    }
  },
  computed: {
    isSalvataggioDisabilitato: function() {
      //console.log("[m]getCurrentState")

      var salvataggioDisabilitato = false;
      /*
      if (this.titolo == "") {
        return true;
      }
      if (this.descProblema == "") {
        return true;
      }
      if (this.selectedSeverity == null) {
        return true;
      }*/

      return salvataggioDisabilitato; //this.$store.state.adp.headersListaPREZZICAPI
    },
    //dateFormatted() {
    //  return this.formatDate(new Date().toISOString().substr(0, 10));
    //},
    computedDateFormatted() {
      return this.formatDate(this.date);
    }
  },
  watch: {
    date(val) {
      this.dateFormatted = this.formatDate(this.date);
      this.dateFormattedISO = this.formatDateISO(this.date);
    }
  },
  created() {
    this.getListaClienti();
    this.getListaCommesse();

    var current_date = new Date();
    var hours = ("0" + current_date.getHours()).slice(-2);
    var mins = ("0" + current_date.getMinutes()).slice(-2);
    var secs = ("0" + current_date.getSeconds()).slice(-2);

    this.oraInizio = hours + ":" + mins;
    this.oraFine = hours + ":" + mins;

    //console.log('created')
    //console.log(' uuid ' + this.$session.get('uuid'))
    //if (!this.$session.get('uuid')) {
    //this.$router.push({ path: '/Login/' })
    //} else {
    //console.log("nuovoticket")
    //this.ricaricaDati()
    //}
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
